import { useCallback, useMemo } from 'react';
import { UndoIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import useQuickFilters from 'framework-listing-lib/hooks/useQuickFilters';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import { useFilterGroups } from 'framework-listing-lib/hooks/useListingLibFilters';
import { useCurrentView } from '../../ViewTabs/hooks/useViewProps';
import { areSameFilterGroups, areSameFilterOperators } from 'framework-listing-lib/utils/filters';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ResetFiltersButton() {
  const {
    onResetFilters,
    initialFilter
  } = useCrmObjectTypeListingFilters();
  const currentView = useCurrentView();
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const shouldRenderClearFilterButton = useMemo(() => {
    if (currentView) {
      // Resetting view filters is handled by the SaveViewsButton
      return false;
    }
    return !areSameFilterGroups(filterGroups, (initialFilter === null || initialFilter === void 0 ? void 0 : initialFilter.filterGroups) || []) || !areSameFilterOperators(quickFilters, (initialFilter === null || initialFilter === void 0 ? void 0 : initialFilter.quickFilters) || []);
  }, [currentView, filterGroups, initialFilter === null || initialFilter === void 0 ? void 0 : initialFilter.filterGroups, initialFilter === null || initialFilter === void 0 ? void 0 : initialFilter.quickFilters, quickFilters]);
  const handleClearAllClick = useCallback(() => {
    trackCrmTableInteraction({
      action: 'click-clear-all-button'
    });
    onResetFilters();
  }, [onResetFilters, trackCrmTableInteraction]);
  if (!shouldRenderClearFilterButton) {
    return null;
  }
  return /*#__PURE__*/_jsx(IconButton, {
    disabled: !shouldRenderClearFilterButton,
    onClick: handleClearAllClick,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.filterBar.resetAllFilters"
    }),
    use: "tertiary-extra-light",
    "data-test-id": "crm-listing-clear-all-filters-button",
    size: "sm",
    children: /*#__PURE__*/_jsx(UndoIcon, {
      size: "200"
    })
  });
}